import { useStore } from 'src/contexts/StoreContext';
import TextLato from 'src/components/text/text-lato/TextLato';
import { styles } from './RightSideProjectTitleInput.styles';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { IconButton } from '@photosi/rn-components/buttons/icon-button/IconButton';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import Button from '@photosi/rn-components/buttons/button/Button';
import { observer } from 'mobx-react-lite';
import { TestIDs } from 'src/constants/testIDs.constants';
import { TITLE_MAX_LENGHT } from '../ProjectTitleInput.constants';
import { Icon } from 'src/theme-v2/icon';

export type RightSideProjectTitleInputProps = {
  isInputFocused: boolean;
  projectTitle: string;
  onPress: () => Promise<void>;
  focusId: string;
  focusOrder: number;
  focusGroup: FocusGroups;
};

export const RightSideProjectTitleInput = observer(
  ({ isInputFocused, projectTitle, onPress, focusGroup, focusId, focusOrder }: RightSideProjectTitleInputProps) => {
    const { i18n } = useStore();

    return isInputFocused ? (
      <>
        <TextLato style={styles.inputCounter}>
          {projectTitle.length}/{TITLE_MAX_LENGHT}
        </TextLato>
        <Button
          testID={TestIDs.SAVE_PROJECT_TITLE}
          onPress={onPress}
          accessible={true}
          accessibilityLabel={i18n.t('header:save-project-title')}
          accessibilityRole="button"
          focusId={`${focusId}-${TestIDs.SAVE_PROJECT_TITLE}`}
          focusOrder={focusOrder}
          focusGroup={focusGroup}
          text={i18n.t('header:save')}
          style={styles.saveButton}
          textStyle={styles.saveButtonText}
        />
      </>
    ) : (
      <IconButton
        testID={TestIDs.EDIT_PROJECT_TITLE}
        onPress={onPress}
        accessible={true}
        accessibilityLabel={i18n.t('header:edit-project-title')}
        accessibilityRole="button"
        focusId={`${focusId}-${TestIDs.EDIT_PROJECT_TITLE}`}
        focusOrder={focusOrder}
        focusGroup={focusGroup}
        iconName={ICON_NAMES.Edit}
        iconStyle={{ height: 16, width: 16, color: Icon.IconColorInteractive }}
      />
    );
  },
);
